module.exports = __webpack_public_path__ + "img/passport.aee712fd.svg";